import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";

export default function Paywall({ title, message }) {
  return (
    <div
      className="soft-card p-8 !bg-[#FFF4DC] border-[#F4D06F] text-center max-w-xl mx-auto"
      data-testid="paywall"
    >
      <div className="mx-auto h-14 w-14 rounded-2xl bg-white grid place-items-center">
        <Lock className="h-7 w-7 text-[#E8899F]" />
      </div>
      <h2 className="mt-4 text-2xl font-bold text-[#16233D]" style={{ fontFamily: "Outfit, sans-serif" }}>
        {title || "Fonctionnalité réservée aux abonnés"}
      </h2>
      <p className="mt-2 text-[#44506B]">
        {message || "Kynoria est verrouillé. Un seul paiement de 47 € et tout s'ouvre, à vie."}
      </p>
      <Link
        to="/abonnement"
        data-testid="paywall-cta"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#16233D] hover:bg-[#16233D] text-white px-6 py-3 font-semibold transition"
      >
        <Crown className="h-4 w-4" /> Voir les formules
      </Link>
    </div>
  );
}
